<div class="d-flex w-100">
    <telxl-search
        [searchText]="searchText()"
        (searchTextChange)="searchChanged($event)"
        [disabled]="disabled()"
        id="contact-directory-search"
        class="w-100"
    />
    @if (showDirectoryFilter()) {
        <div class="ms-2">
            <telxl-dropdown
                size="sm"
                colour="dropdown"
                [outline]="true"
                position="bottom-end"
                [menuItems]="directoryMenuItems()"
                [disabled]="disabled()"
                [selected]="directory"
                (selectedChange)="directory = $event"
            />
        </div>
    }
    @if (showMediaFilter()) {
        <div class="ms-2">
            <telxl-dropdown
                size="sm"
                colour="dropdown"
                [outline]="true"
                position="bottom-end"
                [menuItems]="mediaMenuItems"
                [disabled]="disabled()"
                [selected]="media"
                (selectedChange)="media = $event"
            />
        </div>
    }
</div>
<div
    #scrollContainer
    class="scroll-container mt-2"
    [style.height]="calculateHeight()"
    [style.max-height]="calculateHeight()"
>
    @for (listing of listings(); track listing.id) {
        @if (
            $index === 0 ||
            listing.directory?.id !== listings()[$index - 1]?.directory?.id
        ) {
            <div
                class="d-flex align-items-center directory-name mt-1 mb-2 font-lg weight-medium"
            >
                {{ listing?.directory?.name }}
            </div>
        }
        <telxl-shared-directory-listing-item
            source="external-contacts"
            [customButtonTemplate]="customButtonTemplate()"
            [item]="listing"
            [mode]="mode()"
            [highlight]="highlight()?.toString() === listing.id"
            [displayMediaIcons]="displayMediaIcons()"
            [disabled]="disabled()"
            [selected]="{
                item: selected()?.item ?? [],
                selected: selected()?.id?.toString() === listing.id,
            }"
            [disabled]="disabled()"
            (selectedChange)="selectedChanged($event)"
        />
    } @empty {
        @if (!isLoading()) {
            <div
                class="d-flex flex-column align-items-center justify-content-center h-100"
            >
                <i class="fa-thin fa-face-zipper text-primary"></i>
                <div class="font-xxl mt-4">No data!</div>
                <div class="mt-4">No contacts were found.</div>
            </div>
        } @else {
            <div class="h-100 w-100">
                <telxl-loading size="3rem" />
            </div>
        }
    }
</div>
